import AppleIcon from '~/assets/icons/Apple';
import FacebookIcon from '~/assets/icons/Facebook';
import GoogleIcon from '~/assets/icons/Google';

const OtherLoginOptionsMessage = () => {
  return (
    <div className="flex flex-col items-center gap-1">
      <div className="flex flex-row items-center justify-center gap-3">
        <GoogleIcon colour="black" size={14} />
        <AppleIcon colour="black" width="16" height="16" />
        <FacebookIcon fill="black" width="20" height="20" />
      </div>
      <p className="px-2 text-center font-body text-sm text-grey-read">
        Open in your external browser to see other log in options
      </p>
    </div>
  );
};

export default OtherLoginOptionsMessage;
